import Api from '@/services/API';


/**
 * @typedef {CheckUser}
 */

export default class CheckUser extends Api {
  /**
   * @type {String}
   */
  static base = process.env.VUE_APP_API_HOST

  /**
   * @type {String}
   */
  static resource = '/member/new/check-user'

  /**
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor(resource, options = {}, http = null) {
    super(CheckUser.normalize(CheckUser.base, resource), options, http);
  }

  /**
   * @return {this}
   */
  static build() {
    return new this(this.resource);
  }

  checkUser(email) {
    let data = {
      email: email
    }

    return this.post('', data);
  }
}